import SettingsIcon from "@material-ui/icons/Settings";
import HomeIcon from "@material-ui/icons/Home";
import ForumIcon from "@material-ui/icons/Forum";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";

export const FOOTER_ROUTES = [
  {
    label: "Home",
    icon: <HomeIcon />,
  },
  {
    label: "Insights",
    icon: <ForumIcon />,
  },
  {
    label: "Community",
    icon: <SupervisedUserCircleIcon />,
  },
  {
    label: "Settings",
    icon: <SettingsIcon />,
  },
];
